export const TEAM_DASHBOARD_METRIC_HELP = {
  draft_envelopes:
    'Envelopes saved as drafts in your organization for the selected date range and filters. These have not been sent to signers yet.',
  sent_envelopes:
    'Envelopes that have been sent and are still in progress — waiting for one or more signatures.',
  completed_envelopes:
    'Envelopes where every required signer has finished. Counted for the selected date range and filters.',
  action_required:
    'Sent envelopes where at least one signer still has a pending signature and the envelope needs follow-up.',
  revoked_envelopes:
    'Envelopes cancelled or revoked by the sender before they were fully completed.',
  declined_envelopes:
    'Envelopes where at least one signer chose to decline signing.',
  stuck_envelopes:
    'Sent envelopes with no completed signer signatures yet. Useful for spotting envelopes that may need a reminder or follow-up.',
  saved_templates:
    'Reusable envelope templates saved in your organization during the selected period.',
  organization_users:
    'Total active members in your organization (not suspended).',
  completion_rate:
    'Share of sent envelopes that were fully completed in the selected period. Calculated as completed ÷ sent × 100.',
  avg_time_to_complete:
    'Average time from when an envelope was sent until it was fully completed, shown in hours. Only completed envelopes in the selected period are included.',
  quota_used:
    'How many envelopes your organization has sent against your subscription plan limit. Shows used count, or used / limit when a cap applies.',
  envelope_trends:
    'Envelope activity over time: created, sent, completed, and declined counts. Granularity adjusts by date range (daily, weekly, or monthly).',
  status_breakdown:
    'Number of envelopes in each status (draft, sent, completed, revoked, etc.) for the current filters.',
  active_users:
    'Organization members with active accounts who are not suspended.',
  pending_invites:
    'People invited to join the organization who have not accepted their invite yet.',
  seats_used:
    'Member seats currently in use compared with the total seats allowed on your plan.',
  users_with_zero_activity:
    'Members who had no envelope activity (create, send, or sign) during the selected date range.',
  role_breakdown:
    'How organization members are distributed across roles, such as Admin or Member.',
  avg_signatures_per_envelope:
    'Average number of completed signer signatures per envelope in the selected period.',
  decline_count:
    'Total times signers declined to sign across all envelopes in the selected period.',
  otp_success:
    'OTP verifications that succeeded when signers accessed documents to sign.',
  otp_failure:
    'OTP verification attempts that did not succeed (wrong code, expired, or abandoned).',
  user_sent:
    'Envelopes this user sent during the selected period and filters.',
  user_drafts:
    'Draft envelopes this user created during the selected period and filters. These have not been sent yet.',
  user_completed:
    'Envelopes this user sent that were fully completed during the selected period.',
  user_action_required:
    'This user’s sent envelopes that still have at least one pending signer.',
  user_avg_time_to_complete:
    'Average hours from send to full completion for this user’s completed envelopes in the selected period.',
  user_last_activity:
    'The most recent envelope-related activity for this user in the selected period.',
};
